import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Image } from 'react-bootstrap';
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import 'animate.css';

import '../pages/css/footer.css'
const Footer = () => {


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>


            {/* <footer className="page-footer font-small unique-color-dark wow animate__animated animate__fadeInUp" data-wow-duration='1.2s'> */}
            <footer className="page-footer font-small unique-color-dark" >


                <div className='footer-2'>

                    <div className="firstFooter text-md-left">

                        <div className="row justify-content-center align-items-center">

                            <div className="col-lg-5">

                                <h1 className='wow animate__animated animate__fadeIn' data-wow-duration='1.2s'>Subscribe to<br /> our newsletter</h1>

                            </div>

                            <div className="col-lg-7">
                                <div className="input-group">
                                    <input type="email" className="form-control input-field" placeholder="Enter your email" />
                                    <button className="btn btn-danger btn-sub">Subscribe</button>
                                </div>
                            </div>

                        </div>
                    </div>










                </div>

                <div className="footer-1">

                    <div className="firstFooter text-md-left">

                        <div className="row">

                            <div className="col-lg-3 d-flex align-items-center">
                                 <img src="/logo.png"
                                    className="logo d-inline-block align-top img-fluid wow fadeInDown"
                                    data-wow-duration="0.5s"
                                    alt="Logo"
                                />
                            </div>

                            <div className="col-lg-3">

                                <h6 className="ma-0 text-uppercase font-weight-bold accent-2 mb-4 mt-0 wow animate__animated animate__fadeInUp" data-wow-duration='1.5s'>ADDRESS</h6>

                                <li className="listP wow animate__animated animate__fadeInUp" data-wow-duration='1.5s'>
                                    <Link>125 Aspenmere Drive Chestermere, AB T1X 0P2, Canada</Link>
                                </li>
                            </div>


                            <div className="col-lg-3">

                                <h6 className="ma-0 text-uppercase font-weight-bold accent-2 mb-4 mt-0 wow animate__animated animate__fadeInUp" data-wow-duration='1.5s'>Contact</h6>

                                <li className="foot-listP wow animate__animated animate__fadeInUp" data-wow-duration='1.5s'>
                                    <Link>
                                        <i className="fa fa-envelope mr-3"></i>
                                    </Link>
                                    <a href="mailto:info@bethelcfc.org">
                                        info@bethelcfc.org
                                    </a>
                                </li>
                                <li className="foot-listP wow animate__animated animate__fadeInUp" data-wow-duration='1.5s'>
                                    <Link className="waves-effect waves-light">
                                        <i className="fa fa-phone mr-3"></i>
                                    </Link>
                                    <a href="tel:+1 (403) 796-8811" className="waves-effect waves-light">
                                        +1 (403) 796-8811
                                    </a>
                                </li>

                            </div>




                            <div className="col-lg-3">
                            </div>

                        </div>
                    </div>

                    <div className='footer-lineOne' />



                    <div className="seconeFooter">


                        <div className="secFooter">

                            <div className="dflex">
                                <div className='social-handle wow animate__animated animate__fadeIn' data-wow-duration='1.5s'>
                                    <FaFacebookF />
                                </div>
                                <div className='social-handle wow animate__animated animate__fadeIn' data-wow-duration='1.5s'>
                                    <FaInstagram />
                                </div>
                                <div className='social-handle wow animate__animated animate__fadeIn' data-wow-duration='1.5s'>
                                    <FaXTwitter />
                                </div>
                            </div>

                            <div className="">
                                <Link className="waves-effect waves-light wow animate__animated animate__fadeInUp" data-wow-duration='1.5s'>© 2025 BCFC. All Rights Reserved..</Link>
                            </div>
                        </div>


                    </div>
                </div>




            </footer>





        </>
    );
};

export default Footer;